import 'bootstrap';
import 'jquery';
import 'styles/index.scss';
import 'owl.carousel';
import './main';
